import { PlatformType, getAppVersion, getPlatformType } from '@nibfe/mkt-env-api';
const isMRN = false;
import { compareVersion } from '@/utils/common';
export function getIsSupportVap() {
    if (isMRN) {
        // https://km.sankuai.com/collabpage/1563674584
        // 美团app 12.9.400 及以上版本展示透明视频
        try {
            const version = getAppVersion();
            const platform = getPlatformType();
            const isMt = [PlatformType.mtApp, PlatformType.mtAppWebView].includes(platform);
            const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView].includes(platform);
            if (isMt && version && compareVersion(version, '12.9.400')) {
                return true;
            }
            else if (isDp && version && compareVersion(version, '11.20')) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    }
    else {
        return true;
    }
}
